import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { getPersonaTestimonialsRoute } from "../../../../routers/routeUtils";

import { useUserReviews } from "../../../User/api/queries/useUserReviews";

import { testimonialStyles } from "./styles";
import EmptyTestimonials from "./EmptyTestimonials";
import TestimonialsLoader from "./TestimonialsLoader";
import TestimonialCard from "./TestimonialCard";

const Testimonials = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "testimonials" });
  const { userId } = useParams();
  const { data: reviewsData, isLoading: isReviewsLoading, isError: isReviewsError } = useUserReviews(userId!, 1);

  const navigate = useNavigate();

  if (isReviewsLoading) return <TestimonialsLoader />;
  if (isReviewsError || !reviewsData?.items.length) return <EmptyTestimonials />;

  return (
    <Box sx={testimonialStyles.container}>
      <Typography sx={testimonialStyles.title}>{t("testimonials")}</Typography>
      <TestimonialCard review={reviewsData.items[0]} />
      {reviewsData.items.length > 1 && (
        <Button
          sx={{ borderRadius: 0 }}
          fullWidth
          variant="text-md"
          onClick={() => navigate(getPersonaTestimonialsRoute("player", userId!))}
        >
          {t("showAll")}
        </Button>
      )}
    </Box>
  );
};

export default Testimonials;
